import { render, staticRenderFns } from "./MiroModal.vue?vue&type=template&id=b61a5fac&scoped=true&"
import script from "./MiroModal.vue?vue&type=script&lang=js&"
export * from "./MiroModal.vue?vue&type=script&lang=js&"
import style0 from "./MiroModal.vue?vue&type=style&index=0&id=b61a5fac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a5fac",
  null
  
)

export default component.exports